import { API_URL } from "../../../../../../constants";
import * as httpNetworking from "../../../../../../httpNetworking";
import { ApiKeyResponse } from "../../../../deployment/apiKey/post";

const VERSION = 0;

export async function removeApiKeyForMultiTenantApp(data: {
    deploymentId: string;
    deploymentType: "production" | "development";
    appId: string;
    apiKey: string;
}): Promise<ApiKeyResponse> {
    const { deploymentId, appId, deploymentType, apiKey } = data;

    const options: httpNetworking.DELETERequestConfig = {
        params: {
            deploymentId,
            deploymentType,
            apiKey
        }
    };

    const url = `${API_URL}/saas/multi-tenancy/connection-uri-domain/${appId}/apikey`;

    let response = await httpNetworking.simpleDELETERequest(url, options, VERSION);
    return response.data as ApiKeyResponse;
}
